import React, { FC } from 'react';
import cn from 'classnames';

import { ButtonTypesT } from 'client/types';

import css from './Button.module.scss';

type Props = {
  label: string;
  disabled?: boolean;
  isCustom?: boolean;
  isUnderline?: boolean;
  onClickHandler?: () => unknown;
  className?: string;
  type?: ButtonTypesT;
};

const Button: FC<Props> = (props) => {
  const {
    label,
    type,
    disabled = false,
    isCustom = false,
    isUnderline = false,
    onClickHandler,
    className = '',
  } = props;

  const onButtonClick = (): void => {
    if (onClickHandler) onClickHandler();
  };

  return (
    <button
      type={type}
      className={cn(
        css.default,
        className,
        isCustom && css.custom,
        isUnderline && css.underline,
        disabled && css.disabled,
      )}
      onClick={onButtonClick}
      disabled={disabled}
    >
      {label}
    </button>
  );
};

export default Button;
